import { createSlice } from "@reduxjs/toolkit";
import { AppStorageKeys } from "../Constants/Constants";
import LocalStorage from "../Constants/LocalStorage";
import SessionStorage from "../Constants/SessionStorage";
import { getCurrentUserFromStorage } from "../Constants/Utilities";

const currentUser = getCurrentUserFromStorage();
const initialState = currentUser ? { currentUser } : {};

const authStore = createSlice({
  name: "authentication",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      const { userInfo, remember } = action.payload;
      const { username, access_token, roles } = userInfo;
      const currentUser = { username, access_token, roles };
      state.currentUser = currentUser;
      if (remember) {
        LocalStorage.set(AppStorageKeys.currentUser, currentUser);
      } else {
        SessionStorage.set(AppStorageKeys.currentUser, currentUser);
      }
    },
    loginFailure: (state) => {
      state.currentUser = null;
      LocalStorage.remove(AppStorageKeys.currentUser);
      SessionStorage.remove(AppStorageKeys.currentUser);
    },
    logout: (state) => {
      state.currentUser = null;
      LocalStorage.remove(AppStorageKeys.currentUser);
      SessionStorage.remove(AppStorageKeys.currentUser);
    },
  },
});

export const { loginSuccess, loginFailure, logout } = authStore.actions;

export default authStore.reducer;
